import EnrollmentDatasetPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/EnrollmentDatasetPropertyField';
import EnrollmentEventPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/EnrollmentEventPropertyField';
import FetchedObjectPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/FetchedObjectPropertyField';
import FieldDataField from 'automation-ui-action-features/actions/extension/generic-extension/FieldDataField';
import MultiDataField from 'automation-ui-action-features/actions/extension/generic-extension/MultiDataField';
import PropertyField from 'automation-ui-action-features/actions/extension/generic-extension/PropertyField';
import RelativeDatetimeField from 'automation-ui-action-features/actions/extension/generic-extension/RelativeDatetimeField';
import SingleObjectCoordinatesField from 'automation-ui-action-features/actions/extension/generic-extension/SingleObjectCoordinatesField';
import StaticField from 'automation-ui-action-features/actions/extension/generic-extension/StaticField';
import * as ValueTypeKeys from 'automation-ui-action-features/actions/extension/generic-extension/ValueTypeKeys';
import { Map as ImmutableMap, Record as ImmutableRecord } from 'immutable';
import setIn from 'immutable-less/transmute/setIn';
const RecordByValueType = {
  [ValueTypeKeys.ENROLLMENT_DATASET_COLUMN]: EnrollmentDatasetPropertyField,
  [ValueTypeKeys.ENROLLMENT_EVENT_PROPERTY]: EnrollmentEventPropertyField,
  [ValueTypeKeys.EXTERNAL]: StaticField,
  // remove this case after migration
  [ValueTypeKeys.FETCHED_OBJECT_PROPERTY]: FetchedObjectPropertyField,
  [ValueTypeKeys.FIELD_DATA]: FieldDataField,
  [ValueTypeKeys.MULTI]: MultiDataField,
  [ValueTypeKeys.PROPERTY]: PropertyField,
  [ValueTypeKeys.RELATIVE_DATETIME]: RelativeDatetimeField,
  [ValueTypeKeys.SINGLE_OBJECT_COORDINATES]: SingleObjectCoordinatesField,
  [ValueTypeKeys.STATIC_DEPRECIATED]: StaticField,
  // remove this case after migration
  [ValueTypeKeys.STATIC]: StaticField
};
export default class GenericActionField extends ImmutableRecord({
  fieldKey: null,
  fieldValue: null,
  inputActionName: null
}, 'GenericActionField') {
  constructor(props = {}) {
    const propMap = ImmutableMap(props);
    const {
      fieldValue
    } = props;
    if (!fieldValue) {
      super(propMap);
    } else {
      const newValue = new RecordByValueType[fieldValue.valueType](props.fieldValue);
      super(propMap.set('fieldValue', newValue));
    }
  }
  getFieldValueRecordValueProperty() {
    const fieldValueRecord = this.getFieldValue();
    if (fieldValueRecord instanceof PropertyField) {
      return 'propertyName';
    }
    if (fieldValueRecord instanceof RelativeDatetimeField) {
      return 'timeDelay';
    }
    if (fieldValueRecord instanceof FieldDataField) {
      return 'fieldDataIdentifier';
    }
    if (fieldValueRecord instanceof EnrollmentDatasetPropertyField || fieldValueRecord instanceof EnrollmentEventPropertyField || fieldValueRecord instanceof FetchedObjectPropertyField) {
      return 'propertyToken';
    }
    return 'value';
  }
  getFieldKey() {
    return this.fieldKey;
  }
  getFieldValue() {
    return this.fieldValue;
  }
  getIsFieldValueEmpty() {
    const fieldValue = this.getFieldValue();
    return !fieldValue || fieldValue.getIsValueEmpty();
  }
  setFieldValue(fieldValue) {
    return this.set('fieldValue', new RecordByValueType[fieldValue.valueType](fieldValue));
  }
  setFieldValueValue(value) {
    return setIn(['fieldValue', this.getFieldValueRecordValueProperty()], value, this);
  }
}